import { makeAutoObservable } from "mobx";
import { EnterpriseAccount, ChangeRecord } from "../../models/EnterpriseAccount";
import { EnterpriseAccountApi } from "../../apis/EnterpriseAccount";
import { message } from "antd";

export class EnterpriseAccountManagementPageModel {
    accounts: EnterpriseAccount[] = [];
    searchText: string = "";
    loading: boolean = false;
    selectedAccount: EnterpriseAccount | null = null;
    changeRecords: ChangeRecord[] = [];
    changeRecordsVisible: boolean = false;
    currentPage: number = 1;
    pageSize: number = 10;

    constructor() {
        makeAutoObservable(this);
    }

    setSearchText = (text: string) => {
        this.searchText = text;
    }

    setChangeRecordsVisible = (visible: boolean) => {
        this.changeRecordsVisible = visible;
        if (!visible) {
            this.selectedAccount = null;
            this.changeRecords = [];
            this.currentPage = 1;
        }
    }

    setCurrentPage = (page: number) => {
        this.currentPage = page;
    }

    resetSearch = () => {
        this.searchText = "";
        this.loadAccounts();
    }

    loadAccounts = async () => {
        try {
            this.loading = true;
            this.accounts = await EnterpriseAccountApi.getEnterpriseAccountList({
                searchText: this.searchText
            });
        } catch (error) {
            message.error("加载企业账户列表失败");
        } finally {
            this.loading = false;
        }
    }

    loadChangeRecords = async (account: EnterpriseAccount) => {
        try {
            this.selectedAccount = account;
            this.changeRecords = await EnterpriseAccountApi.getChangeRecordsByEnterprise(account.sellerId);
            this.changeRecordsVisible = true;
        } catch (error) {
            message.error("加载变动记录失败");
        }
    }

    registerWithdraw = async (amount: number, bankNo: number) => {
        if (!this.selectedAccount) return;
        try {
            await EnterpriseAccountApi.registerWithdraw({
                sellerId: this.selectedAccount.sellerId,
                amount,
                bankNo
            });
            message.success("提现登记成功");
            this.loadAccounts();
            if (this.changeRecordsVisible) {
                this.loadChangeRecords(this.selectedAccount);
            }
        } catch (error) {
            message.error("提现登记失败");
        }
    }

    finishWithdraw = async (money: number, bankTransferNo: string) => {
        if (!this.selectedAccount) return;
        try {
            await EnterpriseAccountApi.finishWithdraw({
                sellerId: this.selectedAccount.sellerId,
                money,
                bankTransferNo
            });
            message.success("完成提现操作成功");
            this.loadAccounts();
            if (this.changeRecordsVisible) {
                this.loadChangeRecords(this.selectedAccount);
            }
        } catch (error) {
            message.error("完成提现操作失败");
        }
    }

    charge = async (money: number, bankTransferNo: string, paymentAccount: string) => {
        if (!this.selectedAccount) return;
        try {
            await EnterpriseAccountApi.charge({
                sellerId: this.selectedAccount.sellerId,
                money,
                bankTransferNo,
                paymentAccount
            });
            message.success("充值操作成功");
            this.loadAccounts();
            if (this.changeRecordsVisible) {
                this.loadChangeRecords(this.selectedAccount);
            }
        } catch (error) {
            message.error("充值操作失败");
        }
    }

    cashback = async (money: number, reason: string) => {
        if (!this.selectedAccount) return;
        try {
            await EnterpriseAccountApi.cashback({
                sellerId: this.selectedAccount.sellerId,
                money,
                reason
            });
            message.success("返现操作成功");
            this.loadAccounts();
            if (this.changeRecordsVisible) {
                this.loadChangeRecords(this.selectedAccount);
            }
        } catch (error) {
            message.error("返现操作失败");
        }
    }
} 